import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Detail from './Components/Detail/Detail'
import Home from './Components/Home/Home'
import Listing from './Components/Listing/Listing'
import Login from './Components/Login/Login'
import Register from './Components/Login/Register'
import NotFound from './Components/NotFound'
import PlaceOrder from './Components/PlaceOrder/PlaceOrder'
import OrderList from './Components/PlaceOrder/OdrerList'

const Router = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path='/' element={<Home />} />
                <Route path='/list/:id' element={<Listing />} />
                <Route path='/detail/:id' element={<Detail />} />
                <Route path='/placeorder' element={<PlaceOrder />} />
                <Route path='/viewBooking' element={<OrderList />} />
                <Route path='/login' element={<Login />} />
                <Route path='/register' element={<Register />} />
                <Route path='*' element={<NotFound />} />
            </Routes>
        </BrowserRouter>
    )
}

export default Router